<template>
    <img src="@/assets/icons/icon-heart.png" alt="heart" style="width: 28px;"/>
</template>